<template>
    <section>
        <date-picker v-model="yearSelect" type="year" valueType="format"
            @change="changeCalendar()">
        </date-picker>
        <br>
        <br>
        <v-flex xs2 v-if="timeZoneList.length!=1">
            <span class="data_card__info--label">Zona horaria</span>
            <v-select
              label="Tipo de locación"
              :items="timeZoneList"
              item-value="code"
              item-text="name"              
              v-model="time_zone"
              @blur="activeErrorTimeZone=true"
              :class="time_zone.length<=0&&activeErrorTimeZone?'data_card__err_time_zone':''"
              single-line              
              bottom        
              required           
              color = "blue bold"
              @change="changeCalendar()"
            ></v-select>
        </v-flex>    
        <div v-if="yearSelect !== null && flag_calendar === true && time_zone.length > 0" 
            class="month_mesh">
            <app-month v-for="(month,index) in computedMounths" :key="index"
                :month="index + 1"
                :month-name="month"
                :holidays="getHolidaysForMonth(index + 1)"
                :inalianable-holidays="getInalianableHolidaysForMonth(index + 1)"
                :holidays-info="holidays_info"
                :year="Number(yearSelect)"
                @day-click="handleClick">
            </app-month>   
        </div>
    </section>
</template>

<script>
    import Month from './Month'
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import CountriesInfo from '../../../vue/additionalData/countries.js'

    export default {
        data: () => ({
            localHolidays: [
                { month: 1, year: 2021, days: [] },
            ],
            inalianableHolidays: [
                { month: 1, year: 2021, days: [] },
            ],
            holidays_info: null,
            yearSelect: null,
            flag_calendar: true,
            time_zone: '',
            activeErrorTimeZone: '',
        }),
        components: {
            'app-month': Month,
            DatePicker 
        },
        computed: {
            computedMounths() {
                return ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
                    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']
            },
            countriesList(){
                return CountriesInfo.myCountries
            },
            timeZoneList(){      
                return CountriesInfo.timeZones['Chile'].time_zones
            },
        },
        methods:{
            getHolidaysForMonth(monthIndex){
                const month = this.localHolidays.find((e) => e.month == monthIndex )
                if(month) return month.days 
                return []
            },
            getInalianableHolidaysForMonth(monthIndex){
                const month = this.inalianableHolidays.find((e) => e.month == monthIndex )
                if(month) return month.days 
                return []
            },
            changeCalendar(){
                localStorage.removeItem('selected_time_zone')
                this.flag_calendar = false
                setTimeout(() => { 
                    this.findHolidays();
                    this.flag_calendar = true 
                }, 50);
                if(this.time_zone !== ''){
                    localStorage.setItem('selected_time_zone', this.time_zone)
                }                    
            },
            handleClick(event){
                event.time_zone = this.time_zone
                this.createOrDeleteHoliday([event]);
            },
            findHolidays(){
                let params = { year: Number(this.yearSelect), time_zone: this.time_zone}
                this.localHolidays = [ { month: 1, year: 2021, days: [] }, ]
                this.inalianableHolidays = [ { month: 1, year: 2021, days: [] }, ]
                try {
                    this.$http.get('app/holidays/get_holidays',{
                    headers:
                    {
                        "X-Device-ID" : this.getDeviceId(),
                        "Authorization" : 'Bearer ' + this.getUserToken()
                    },
                    params
                    })
                    .then(function(response){
                        this.localHolidays = response.body.holidays;   
                        this.inalianableHolidays = response.body.inalianable_holidays;
                        this.holidays_info = response.body.holidays_info
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                    }, function(response){
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                    })
                } catch (e) {
                    alert(e.message)
                }
            },
            createOrDeleteHoliday(data){
                try {
                    this.$http.post('app/holidays/create', {
                            data: this.encrypt(data).toString()},
                        {
                        headers:{
                            "X-Device-ID" : this.getDeviceId(),
                            "Authorization" : 'Bearer ' + this.getUserToken()
                            }
                        })
                    .then(function(response){
                        this.findHolidays();
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                    }, function(response){
                        if(response.body.meta != undefined && response.body.meta != null){
                            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                                this.checkToken(response.body.meta.authentication_token)
                            }
                        }
                        // alert(response);
                    })
                } catch (e) {
                    alert(e.message)
                }
                
            },
        }    

    }
</script>


// WEBPACK FOOTER //
// src/components/views/locations/Holidays.vue